<section class="container-fluid summary-panel">
    <app-page-heading [key]="'local-loads.search.list.page-title'"
                      [carriers]="carriers" [(selectedCarrier)]="selectedCarrier" (selectedCarrierChange)="selectCarrier($event)">
    </app-page-heading>

    <app-data-list [loadPage]="loadPage" [(filters)]="filters" [filtersBase]="filtersBase" [itemTemplate]="itemTemplate" [extraActionFields]="assignVehicle" [pageSize]="10" [loadAtStartup]="false"
                   (onPageChange)="pageChanged()" [filtersComponent]="dataFilters" (onLoad)="onLoad($event)" (beforeReset)="beforeReset()" [preventPageChange]="hasSelectedLoads()">
        <app-data-filters #dataFilters [opened]="true" [fullWidth]="true" [disableSearch]="!selectedCarrier">
            <app-data-filter-group [useAvailableWidth]="true">
                <app-data-filter-select [labelKey]="'local-loads.search.list.filters.import.label'" [(model)]="selectedImportId"
                                        [options]="importsOptions" (modelChange)="updateImportIdFilters()" [useOptionLabel]="true"></app-data-filter-select>
                <app-data-filter-autocomplete [labelKey]="'local-loads.search.list.filters.vehicle.label'" [name]="'vehicle'"
                                              [placeholderKey]="'local-loads.search.list.filters.vehicle.placeholder'"
                                              [notFoundTextKey]="'local-loads.search.list.filters.vehicle.notfound'"
                                              [(model)]="filters.vehicles" [options]="vehicleSearchList"
                                              [multiple]="true">
                </app-data-filter-autocomplete>
            </app-data-filter-group>
            <app-data-filter-group [useAvailableWidth]="true">
                <app-data-filter-multi-string-input [labelKey]="'local-loads.search.list.filters.load-number.label'"
                                                    [placeholderKey]="'local-loads.search.list.filters.load-number.placeholder'"
                                                    [(model)]="filters.loadNumbers">
                </app-data-filter-multi-string-input>

                <app-data-filter-multi-string-input [labelKey]="'local-loads.search.list.filters.delivery-number.label'"
                                                    [placeholderKey]="'local-loads.search.list.filters.delivery-number.placeholder'"
                                                    [separators]="[',', ';']"
                                                    [(model)]="filters.shipment_number">
                </app-data-filter-multi-string-input>
            </app-data-filter-group>

            <app-data-filter-group [spaceBetween]="true">
                <app-data-filter-group>

                    <app-data-filter-date [labelKey]="'local-loads.search.list.filters.planned.start.label'"
                        [placeholderKey]="'local-loads.search.list.filters.planned.start.placeholder'"
                        [(model)]="plannedStartDate" [maxDate]="plannedEndDate"
                        (modelChange)="updatePlannedDateFilters()"></app-data-filter-date>

                    <app-data-filter-date [labelKey]="'local-loads.search.list.filters.planned.end.label'"
                        [placeholderKey]="'local-loads.search.list.filters.planned.end.placeholder'"
                        [(model)]="plannedEndDate" [minDate]="plannedStartDate"
                        (modelChange)="updatePlannedDateFilters()"></app-data-filter-date>
                </app-data-filter-group>
            </app-data-filter-group>

            <app-data-filter-group>
                <app-data-filter-checkbox [name]="'local-loads-status'" [labelKey]="'local-loads.search.list.filters.status.label'"
                                       [(model)]="filters.status" [options]="statusOptions"></app-data-filter-checkbox>

                <app-data-filter-switch class="data-filter-switch" [labelKey]="'local-loads.search.list.filters.vehicle.unassigned'"
                                       [(model)]="filters.showUnassigned" ></app-data-filter-switch>
            </app-data-filter-group>

            <app-data-filters-button [labelKey]="'local-loads.search.list.filters.export'" [type]="'primary'"
                                     (onClick)="openConfirmExportLoads(exportLocalLoadsModal)">
                <i class="fa fa-download"></i>
            </app-data-filters-button>
        </app-data-filters>

        <ng-template #assignVehicle let-items="items">
            <div class="assign-vehicle-container" *ngIf="canAssignVehicle">
                <div class="checkbox">
                   <label>
                       <input type="checkbox" (click)="selectAllLoads(items)"  [checked]="someNotSelected(items) ? null : 'checked'" >
                       <i class="fa checkbox-icon"></i>
                   </label>
                </div>
                <div class="action-buttons">
                    <button class="btn btn-success" (click)="openChoseVehicleList(choseVehicleModal, items)" [i18n]="[{target: 'innerHTML', key: 'local-loads.update.assign'}]" [disabled]="noneSelected(items)"></button>
                    <button class="btn btn-warning" (click)="openUnassignLoads(unassignLocalLoadsModal, items)" [i18n]="[{target: 'innerHTML', key: 'local-loads.update.unassign-vehicle'}]" [disabled]="noneSelected(items)"></button>
                </div>
            </div>
        </ng-template>

        <ng-template #itemTemplate let-item="item">
            <div class="ibox float-e-margins loads-list">

                <div class="ibox-title collapsible border-primary" [ngClass]="{ 'collapsed': !item.expanded }" (click)="selectLoad(item)">
                    <div class="local-load-list-item">
                        <div class="checkbox" *ngIf="canAssignVehicle">
                            <label>
                                <input type="checkbox" (click)="item.selectItem()" [checked]="item.isSelected ? 'checked': null">

                                <i class="fa checkbox-icon flip-checkbox-icon"></i>
                            </label>
                        </div>

                        <div class="local-load-list-item-column no-wrap">
                            <div class="local-load-list-item-row">
                                <div class="local-load-list-item-column">
                                    <div [title]="item.loadNumber">
                                        <span [i18n]="'local-loads.search.list.load-number'"></span>&nbsp;
                                        <span class="filterable" (click)="filterByLoadNumber(item.loadNumber)">#{{ item.loadNumber }}</span>
                                    </div>
                                </div>
                                <div class="local-load-list-item-column">
                                    <div [popover]="salesOrderPopTemplate"
                                         placement="top" container="body"
                                         triggers="mouseenter:mouseleave">
                                        <span [i18n]="'local-loads.search.list.deliveries'"></span>&nbsp;
                                        <span class="filterable" (click)="filterByShipmentNumbers(item.shipmentNumbers)">{{ item.shipmentNumbers }}</span>
                                    </div>
                                </div>
                                <ng-template #salesOrderPopTemplate>
                                    <chp-delivery-and-sales-order-numbers
                                        [stringDeliveryNumbers]="item.shipmentNumbers"
                                        [salesOrderNumbers]="item.salesOrderNumber">
                                    </chp-delivery-and-sales-order-numbers>
                                </ng-template>

                            </div>
                            <div [title]="item.firstLocalStop.location.name">
                                <span [i18n]="'local-loads.search.list.from-new'"></span>&nbsp;
                                <span>{{item.firstLocalStop.location.name}}</span>&nbsp;
                                <a *ngIf="userCanManageLocations; else noLinkFrom"
                                   class="badge badge-link cmaweb-link"
                                   target="_blank"
                                   [href]="link.goToLocationGlid(item.firstLocalStop.location.glid)"
                                   (click)="$event.stopPropagation()">
                                    {{item.firstLocalStop.location.glid}}
                                </a>
                                <ng-template #noLinkFrom>
                                    <span>({{item.firstLocalStop.location.glid}})</span>
                                </ng-template>
                            </div>
                            <div [title]="item.lastLocalStop.location.name">
                                <span [i18n]="'local-loads.search.list.to-new'"></span>&nbsp;
                                <span>{{item.lastLocalStop.location.name}}</span>&nbsp;
                                <a class="badge badge-link cmaweb-link" target="_blank"
                                   *ngIf="userCanManageLocations;  else noLinkTo"
                                   [href]="link.goToLocationGlid(item.lastLocalStop.location.glid)"
                                   (click)="$event.stopPropagation()">
                                    {{item.lastLocalStop.location.glid}}
                                </a>
                                <ng-template #noLinkTo>
                                    <span>({{item.lastLocalStop.location.glid}})</span>
                                </ng-template>
                            </div>
                        </div>

                        <div class="local-load-list-item-column" style="align-items: flex-end;">
                            <div>
                                <i class="fa fa-truck"></i>
                                <span>
                                    <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.vehicle'}]"></span>
                                    <span *ngIf="item.vehicle; else unassigned" class="filterable" (click)="filterByVehicle(item.vehicle)">{{ item.vehicle }}</span>
                                    <ng-template #unassigned>
                                        <span><em [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.unassigned_load'}]"></em></span>
                                    </ng-template>
                                </span>
                            </div>
                            <app-local-load-status [status]="item.status"></app-local-load-status>
                        </div>

                        <div class="local-load-list-item-column shrink">
                            <div class="ibox-tools">
                                <a class="collapse-link" draggable="false">
                                    <i class="fa" [ngClass]="{ 'fa-plus': !item.expanded, 'fa-minus': item.expanded }"></i>
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="ibox-content no-padding local-load-list-item-stops" *ngIf="item.expanded">
                    <div *ngFor="let stop of item.stops" class="local-load-list-item-stop" (click)="selectStop(stop)"
                         [ngClass]="{ 'active': selectedStop === stop }">
                        <div *ngIf="stop.type === 'Pick'" [title]="stop.location.name" class="local-load-list-item-stop-location">
                            <span class="chep-icon-pick-up"></span>
                            <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.collect-from', params: {location: stop.location.name}}]"></span>
                        </div>
                        <div *ngIf="stop.type === 'Drop'" [title]="stop.location.name" class="local-load-list-item-stop-location">
                            <span class="chep-icon-drop-off"></span>
                            <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.deliver-to', params: {location: stop.location.name}}]"></span>
                        </div>
                        <div [title]="stop.plannedArrival | fullDate" class="local-load-list-item-stop-arrival">
                            <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.planned-arrival',
                                  params: { date: stop.plannedArrival | fullDate:true: true }}]">
                            </span>
                            <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.planned-departure',
                                  params: { date: stop.plannedDeparture  | onlyTime: stop.plannedArrival}}]">
                            </span>
                        </div>
                    </div>
                    <div class="local-load-list-item-stop">
                        <div class="local-load-list-item-stop-location">
                            <span class="fa fa-upload"></span>
                            <span class="filterable" (click)="filterByImport(item.localLoadImport)"
                                  [i18n]="[{target: 'innerHTML', key: item.localLoadImport.source === 'FILE' ? 'local-loads.search.list.importFILE' : 'local-loads.search.list.importTMS',
                                  params: {importId: item.localLoadImport.importedAt | fullDate: true: true}}]">
                            </span>
                        </div>
                        <div class="local-load-list-item-stop-location">
                            <div class="item-blujay-logo">
                                <img *ngIf="item.localLoadImport.source === 'BLUJAY'" class="blujay-logo" src="/assets/blujay-logo.png" alt="BluJay"/>
                            </div>
                        </div>
                        <div class="local-load-list-item-stop-location">
                            <span class="fa fa-clock"></span>
                            <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.imported-at',
                                    params: {date: item.localLoadImport.importedAt | dateDiffFromNow | async}}]">
                            </span>
                        </div>
                        <div class="local-load-list-item-stop-location">
                            <span class="fa fa-clock"></span>
                            <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.updated-at',
                                  params: {date: item.updatedAt | dateDiffFromNow | async}}]">
                            </span>
                        </div>
                    </div>

                </div>
            </div>
        </ng-template>
    </app-data-list>
</section>

<ng-template #exportLocalLoadsModal>
    <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.modals.export.body', params: { count: searchResult? searchResult.totalCount : 0 }}]"></span>
</ng-template>

<ng-template #unassignLocalLoadsModal>
    <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.modals.unassign.body', params: { count: hasSelectedLoads() }}]"></span>
</ng-template>

<ng-template #choseVehicleModal>
    <ng-select
        [items]="vehicleList"
        [addTag]="true"
        [i18n]="[{target: 'attribute:placeholder', key: 'local-loads.search.list.filters.vehicle.assign-placeholder'}]"
        [placeholder]="'local-loads.search.list.filters.vehicle.assign-placeholder' | translate"
        [hideSelected]="true"
        [(ngModel)]="chosenVehicle">
    </ng-select>
</ng-template>
